import React from "react";
import "./ContactUs.css";

const ContactUs = () => {
  return (
    <>
      <div className="background">
        <div className="container">
          <div className="screen">
            <div className="screen-header">
              <div className="screen-header-left">
                <div className="screen-header-button close"></div>
                <div className="screen-header-button maximize"></div>
                <div className="screen-header-button minimize"></div>
              </div>
              <div className="screen-header-right">
                <div className="screen-header-ellipsis"></div>
                <div className="screen-header-ellipsis"></div>
                <div className="screen-header-ellipsis"></div>
              </div>
            </div>
            <div className="screen-body">
              <div className="screen-body-item left">
                <div className="app-title">
                  <span>CONNECT</span>
                  <span>w/ ME</span>
                </div>
                <div className="app-contact">
                  Cell / whatsApp : (+880) 1 3059 52 357
                </div>
                <p style={{ fontSize: "12px", color: "grey" }}>
                  Email: ahmedtowsikzap@gmail.com
                </p>
              </div>
              <div className="screen-body-item">
                <div className="app-form">
                  <div className="app-form-group">
                    <input
                      className="app-form-control"
                      placeholder="your name?"
                    />
                  </div>
                  <div className="app-form-group">
                    <input
                      className="app-form-control"
                      placeholder="Your EMAIL"
                    />
                  </div>
                  <div className="app-form-group message">
                    <input
                      className="app-form-control"
                      placeholder="Drop your MESSAGE"
                    />
                  </div>
                  <div className="app-form-group buttons">
                    <button className="app-form-button">SEND</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="credits">
            ©Copyright 2023. All Rights Reserved
            <a className="credits-link" href="#" target="_blank">
              Ahmed Towsik.
            </a>
          </div>
        </div>
      </div>
    </>
  );
};

export default ContactUs;
